var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"subscribe-form"},[_c('div',{staticClass:"subscribe-form_ico"},[_c('img',{attrs:{"src":"/img/ico-phone.svg","width":"55","alt":""}})]),_c('div',{staticClass:"subscribe-form_text"},[_vm._v("Доступ ограничен. Пожалуйста пополните Ваш счет мобильного телефона и повторите попытку позднее.")])])])
}]

export { render, staticRenderFns }